import { MenuAction } from '@shared/interfaces/header/menu-action';
import { Edit, FileEdit } from 'lucide-angular';

export const meteringPointCalculationMenuAction: MenuAction[] = [
  { id: 'change', title: 'meteringPoint.calculation.create.title', icon: FileEdit },
  { id: 'htx', title: 'meteringPoint.calculation.htx.title', icon: Edit }
];
